module.exports = __webpack_public_path__ + "img/dorm-notin.2f629797.png";